// extracted by mini-css-extract-plugin
module.exports = {"camMidrollUpsell":"MidrollCTA_camMidrollUpsell__ka4YT"};